// (function () {

//     const toggleTax = () => {
//         const taxEls = document.querySelectorAll('.price .tax-product');
//         const taxIcons = document.querySelectorAll('svg.uae-currecny-icon');
//         const selected = document.querySelector('.buckscc-currency-box .bucks-selected');

//         if (!selected) return;

//         const text = selected.textContent.toUpperCase();
//         const isAED = text.includes('AED');

//         // Toggle tax text
//         taxEls.forEach(el => {
//             el.style.display = isAED ? 'block' : 'none';
//         });

//         // Toggle tax icon
//         taxIcons.forEach(icon => {
//             icon.style.display = isAED ? 'block' : 'none';
//         });
//     };

//     // Run once immediately
//     toggleTax();

//     // 🔥 Observe entire body (AJAX-safe, Bucks-safe)
//     const observer = new MutationObserver(toggleTax);

//     observer.observe(document.body, {
//         childList: true,
//         subtree: true
//     });
// })();

// (function () {

//     let switching = false;

//     const currencyToMarket = {
//         AED: 'AE',
//         SAR: 'SA',
//         OMR: 'OM',
//         BHD: 'BH',
//         QAR: 'QA',
//         EGP: 'EG',
//         JOD: 'JO',
//         LBP: 'LB'
//     };

//     function redirectByCountry(countryCode) {

//         const currentPath = window.location.pathname.replace(/^\/ar/, '');
//         const baseUrl = window.location.origin;

//         // UAE = English
//         if (countryCode === 'AE') {
//             // if (window.location.pathname.startsWith('/ar')) {
//             //     window.location.href = baseUrl + currentPath;
//             // }
//         }
//         // All others = Arabic
//         else {
//             if (!window.location.pathname.startsWith('/ar')) {
//                 window.location.href = baseUrl + '/ar' + currentPath;
//             }
//         }
//     }

//     function changeMarket(countryCode) {

//         switching = true;

//         const formData = new FormData();
//         formData.append('country_code', countryCode);
//         formData.append('form_type', 'localization');
//         formData.append('_method', 'put');

//         fetch('/localization', {
//             method: 'POST',
//             body: formData
//         })
//         .then(() => location.reload())
//         .catch(() => switching = false);
//     }

//     /* =========================
//        FIRST LOAD (LANG ONLY)
//     ========================== */

//     document.addEventListener('DOMContentLoaded', function () {

//         // Stop auto language only if user manually changed language
//         if (localStorage.getItem('is_manual') === 'true') return;

//         const shopifyCountry = window.Shopify?.country;

//         if (shopifyCountry) {
//             redirectByCountry(shopifyCountry);
//         }

//     });

//     /* =========================
//        MARKET CLICK
//        (NO is_manual here)
//     ========================== */

//     document.addEventListener('click', function (e) {

//         const item = e.target.closest('.converterTriggers');
//         if (!item || switching) return;

//         const currency = item.getAttribute('rel') || item.id;
//         if (!currency) return;

//         const targetCountry = currencyToMarket[currency];
//         if (!targetCountry) return;

//         // Country change should NOT lock language
//         changeMarket(targetCountry);

//     });

//     /* =========================
//        LANGUAGE CLICK
//        (ONLY place is_manual)
//     ========================== */

//     document.addEventListener('click', function(e) {

//         const lang = e.target.closest('.ly-languages-switcher-link');
//         if (!lang) return;

//         // User explicitly chose language → lock it
//         localStorage.setItem('is_manual', 'true');

//     });

// })();


/* =========================================
   TAX VISIBILITY MODULE
========================================= */

class TaxVisibility {

    constructor() {

        this.taxSelector = '.price .tax-product';
        this.iconSelector = 'svg.uae-currecny-icon';
        this.currencySelector = '.buckscc-currency-box .bucks-selected';

        this.observer = null;
        this.timeout = null;

    }

    init() {

        this.toggleTax();
        this.observeDom();

    }

    getSelectedCurrency() {

        const selected = document.querySelector(this.currencySelector);

        if (!selected) return '';

        return selected.textContent.trim().toUpperCase();

    }

    toggleTax() {

        const currency = this.getSelectedCurrency();
        const isAED = currency.includes('AED');

        const taxEls = document.querySelectorAll(this.taxSelector);
        const taxIcons = document.querySelectorAll(this.iconSelector);

        taxEls.forEach(el => {
            el.style.display = isAED ? 'block' : 'none';
        });

        taxIcons.forEach(icon => {
            icon.style.display = isAED ? 'block' : 'none';
        });

    }

    observeDom() {

        this.observer = new MutationObserver(() => {

            clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {
                this.toggleTax();
            }, 100);

        });

        this.observer.observe(document.body, {
            childList: true,
            subtree: true
        });

    }

}

/* =========================================
   MARKET + LANGUAGE SWITCHER
========================================= */

class MarketLanguageSwitcher {

    constructor() {

        this.switching = false;

        this.currencyToMarket = {
            AED: 'AE',
            SAR: 'SA',
            OMR: 'OM',
            BHD: 'BH',
            QAR: 'QA',
            EGP: 'EG',
            JOD: 'JO',
            LBP: 'LB',
            KWD: 'KW'

        };

    }

    init() {

        this.handleInitialLoad();
        this.bindCurrencySwitcher();
        this.bindLanguageSwitcher();

    }

    /* =========================================
       INITIAL PAGE LOAD
    ========================================= */

    handleInitialLoad() {

        document.addEventListener('DOMContentLoaded', () => {

            const isManual = localStorage.getItem('is_manual');

            // Stop auto redirect if user selected language manually
            if (isManual === 'true') return;

            const pathname = window.location.pathname;

            // If user manually opened /ar
            // respect it and stop redirect
            if (pathname.startsWith('/ar')) {

                localStorage.setItem('is_manual', 'true');

                return;

            }

            const shopifyCountry = window.Shopify?.country;

            if (shopifyCountry) {
                this.redirectByCountry(shopifyCountry);
            }

        });

    }

    /* =========================================
       REDIRECT LANGUAGE BY COUNTRY
    ========================================= */

    redirectByCountry(countryCode) {

        const pathname = window.location.pathname;
        const baseUrl = window.location.origin;

        const currentPath = pathname.replace(/^\/ar(\/|$)/, '/');
        const cleanPath = currentPath === '/' ? '' : currentPath;

        // UAE = English
        if (countryCode === 'AE') {

            // Remove /ar if exists
            if (pathname.startsWith('/ar')) {

                localStorage.removeItem('is_manual');

                window.location.href = baseUrl + cleanPath;

            }

            return;

        }

        // Other countries = Arabic
        else {

            // Add /ar if missing
            if (!pathname.startsWith('/ar')) {

                window.location.href = baseUrl + '/ar' + cleanPath;

            }

        }

    }

    /* =========================================
       CHANGE SHOPIFY MARKET
    ========================================= */

    changeMarket(countryCode) {

        this.switching = true;

        const formData = new FormData();

        formData.append('country_code', countryCode);
        formData.append('form_type', 'localization');
        formData.append('_method', 'put');

        fetch('/localization', {
            method: 'POST',
            body: formData
        })
            .then(() => {

                const pathname = window.location.pathname;
                const baseUrl = window.location.origin;

                const currentPath = pathname.replace(/^\/ar(\/|$)/, '/');
                const cleanPath = currentPath === '/' ? '' : currentPath;

                // UAE → English
                if (countryCode === 'AE') {

                    localStorage.removeItem('is_manual');

                    window.location.href = baseUrl + cleanPath;

                }

                // Other markets → Arabic
                else {

                    window.location.href = baseUrl + '/ar' + cleanPath;

                }

            })
            .catch(error => {

                console.error('Market switch failed:', error);

                this.switching = false;

            });

    }

    /* =========================================
       CURRENCY SWITCH CLICK
    ========================================= */

    bindCurrencySwitcher() {

        document.addEventListener('click', (e) => {

            const item = e.target.closest('.converterTriggers');

            if (!item || this.switching) return;

            const currency = item.getAttribute('rel') || item.id;

            if (!currency) return;

            const targetCountry = this.currencyToMarket[currency];

            if (!targetCountry) return;

            // Market decides language automatically
            localStorage.removeItem('is_manual');

            this.changeMarket(targetCountry);

        });

    }

    /* =========================================
       LANGUAGE SWITCH CLICK
    ========================================= */

    bindLanguageSwitcher() {

        document.addEventListener('click', (e) => {

            const lang = e.target.closest('.ly-languages-switcher-link');

            if (!lang) return;

            // User manually selected language
            localStorage.setItem('is_manual', 'true');

        });

    }

}

/* =========================================
   INITIALIZE
========================================= */

document.addEventListener('DOMContentLoaded', () => {

    const taxVisibility = new TaxVisibility();
    taxVisibility.init();

    const marketLanguageSwitcher = new MarketLanguageSwitcher();
    marketLanguageSwitcher.init();

});